<script>
export default {
  inheritAttrs: false,
  name: "MasterSelectField",
  render(h){
    const children = Object.keys(this.$slots).map(slot =>
      h("template", { slot }, this.$slots[slot])
    );
    return h("VAutocomplete", {
      props: {
        "item-text": "name",
        "item-value": "id",
        ...this.$attrs,
        ...this.$props,
      },
      on: this.$listeners,
      scopedSlots: this.$scopedSlots
    }, children);
  }
}
</script>
